import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import {
  backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web--source/common/localization";
import React from "react";

import { useActionTypes } from "../hooks/useActionTypes";
import { IModalContent } from "../hooks/useModalContent";
import { useShowMessage } from "../hooks/useShowMessage";
import { QuickActionType } from "../types";

import { IMessageInfoProps } from "./types";

interface IButtonTextProps extends IMessageInfoProps {
  modalContent: Readonly<IModalContent> | undefined;
}

export const ButtonText: React.FC<IButtonTextProps> = ({
  selectedOption,
  dropdownOptions,
  modalContent,
}) => {
  const { actionType } = useActionTypes();
  const { showEmptyState } = useShowMessage(dropdownOptions, selectedOption);
  const { strictLocalize } = useStrictLocalization();
  if (selectedOption && actionType?.id === QuickActionType.CONTACT_A_BRAND) {
    return strictLocalize(
      {
        defaultMessage: "Contact {brandName}",
        description: {
          text: "Button for a retailer to contact a brand",
        },
      },
      backwardsCompatibleValues({ brandName: selectedOption.name })
    );
  }
  if (showEmptyState) {
    return isRetailer()
      ? strictLocalize({
          defaultMessage: "Back to Retailer Guides",
          description: {
            text: "Button to return to all retailer guides",
          },
        })
      : strictLocalize({
          defaultMessage: "Back to Brand Guides",
          description: {
            text: "Button to return to all brand guides",
          },
        });
  }
  return modalContent?.buttonText;
};
